import Base from '../_base'
import { BITRIX_API } from './instance'
import {
  HH_VACANCIES,
  HH_SPECIALIZATIONS,
  HH_REGIONS,
  HH_SEND_FORM,
} from '@/config/bitrix-endpoints'

export interface HhVacanciesParams {
  region?: number
  specialization?: number
  name?: string
  page?: number
  size?: number
}

export default class BitrixRequests extends Base {
  async getHhVacancies(params: HhVacanciesParams = {}) {
    return BITRIX_API(this.$ctx).get(HH_VACANCIES, { params })
  }

  async getHhSpecializations() {
    return BITRIX_API(this.$ctx).get(HH_SPECIALIZATIONS)
  }

  async getHhRegions() {
    return BITRIX_API(this.$ctx).get(HH_REGIONS)
  }

  async getHhVacancyDetail(code: string) {
    return BITRIX_API(this.$ctx).get(`${HH_VACANCIES}/${code}`)
  }

  async sendHhForm(params: {
    elementId: number
    title: string
    description: string
    files?: File[]
  }) {
    const formData = new FormData()
    formData.append('elementId', String(params.elementId))
    formData.append('title', params.title)
    formData.append('description', params.description)
    if (params.files?.length) {
      params.files.forEach((file) => formData.append('files[]', file))
    }
    return BITRIX_API(this.$ctx).post(HH_SEND_FORM, formData)
  }
}
